<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_19"></a><a id="chapter1"></a>MARY JO BANG</h2>
<h3 class="h3"><a id="sec2"></a><span class="small">FROM</span> <em>The Eye Like a Strange Balloon</em></h3>
<h4 class="h4"><a id="sec3"></a>High Art</h4>
<p class="poem">There’s a city outside<br/>the mind. Another inside.<br/>A mind full of something<br/>becoming because.<br/>A face too small for this red mouth. Look how</p>
<p class="poem">the line isn’t a street anymore<br/>but a track. Like that. The graveled<br/>shroud of a train. I’m not usually like<br/>this. A linkable Like arrives without its What.<br/>Parks the car.</p>
<p class="poem">I remember the camera.<br/>The clear click. The clean cutting off<br/>of the instant. Good-bye, good-bye.<br/>The slide in the sleeve.<br/>This opening eye. Wanting to take</p>
<p class="poem">everything in, sequence after sequence.<br/>The framed now that never ends ending;<br/>the blue suit pulled from a pool<br/>of aqua dreaming.<br/>Not knowing why aside</p>
<p class="poem"><a id="page_20"></a>from theory. Sexual configurations<br/>of glamour. What is the scene?<br/>What is the cover? The frozen waiting<br/>for focus and drive.<br/>Look, look, look. Art is what</p>
<p class="poem">looking takes you to. A red mouth<br/>opening to say,<br/>Don’t look away.<br/>I’m not usually like this.<br/>The camera sliding by with its aperture</p>
<p class="poem">open. Form, repetition, constructs,<br/>content, it happens. Here is the needle<br/>that speeds the plot to the ambush.<br/>It happens. The Whole Truth shading desire.<br/>Atmospherics predominating</p>
<p class="poem">over drama. Chiaroscuro focused<br/>on a point of desperation.<br/>The recurrent dream of a catalog<br/>of surprise revelations.<br/>Having makes wanting</p>
<p class="poem">continue a darkness both familiar<br/>and strange.<br/>“What have you got there?”<br/>“A translation of a story of a dream<br/>world.” The sequence of events exists.</p>
<p class="poem">Here, one; here two;<br/>here, buckle; here shoe.<br/>Now let there be sound.<br/>Now let there be light.<br/>Once there was this now.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?608b6597